import React from 'react';

interface LogoProps {
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ className = "w-8 h-8" }) => {
  return (
    <svg
      version="1.1"
      id="Logo_Shopiweb_Manager"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 500 500"
      className={className}
      aria-hidden="true"
    >
      <g className="fill-current">
        <path d="M235.8,78.2H135.4c-0.5-2.7-0.7-5.5-0.7-8.3c0-28.1,22.8-50.9,50.9-50.9c28.1,0,50.9,22.8,50.9,50.9
          C236.5,72.7,236.3,75.5,235.8,78.2z M77.6,411.5h43.1V346c17.2,12.8,34.7,22.5,52.5,29.1c17.8,6.6,34.9,9.9,51.3,9.9
          c15.6,0,27.7-3.1,36.3-9.3c8.6-6.2,12.9-14.5,12.9-24.9v-1.2c0-6-1.9-11.2-5.7-15.6c-3.8-4.4-9-8.3-15.6-11.7
          c-6.6-3.4-14.2-6.4-22.8-9l-26.7-8.1c-11.6-3.6-23.3-7.6-35.1-12c-11.8-4.4-22.4-10.1-31.8-17.1S119,260.4,113,250.2
          c-6-10.2-9-22.9-9-38.1v-1.2c0-14.8,2.9-28.2,8.7-40.2c5.8-12,13.8-22.2,24-30.6c10.2-8.4,22.2-14.8,36-19.2
          c13.8-4.4,28.5-6.6,44.1-6.6c20,0,40.2,3.2,60.6,9.6c5.9,1.9,11.6,3.9,17.3,6.2V78.2h-42.1c0.3-2.7,0.5-5.5,0.5-8.3
          c0-37.2-30.2-67.4-67.4-67.4s-67.4,30.2-67.4,67.4c0,2.8,0.2,5.6,0.5,8.3H61.8L26.6,411.5H77.6L77.6,411.5z"/>
        <path d="M304.4,201.9c-15.2-9.2-30.6-16.5-46.2-21.9c-15.6-5.4-30-8.1-43.2-8.1c-14,0-24.9,3-32.7,9
          c-7.8,6-11.7,13.6-11.7,22.8v1.2c0,5.6,2,10.5,6,14.7c4,4.2,9.3,8,15.9,11.4s14.2,6.6,22.8,9.6c8.6,3,17.5,5.9,26.7,8.7
          c11.6,3.6,23.2,7.8,34.8,12.6c11.6,4.8,22.1,10.7,31.5,17.7c9.4,7,17.1,15.5,23.1,25.5c6,10,9,22.2,9,36.6v1.2
          c0,16.8-3,31.4-9,43.8c-6,12.4-14.3,22.7-24.9,30.9c-10.6,8.2-23.1,14.4-37.5,18.6c-14.4,4.2-29.8,6.3-46.2,6.3
          c-22.8,0-45.9-4-69.3-12c-6.6-2.3-13.2-4.9-19.5-7.7v74.6h294.3L392.3,161h-88L304.4,201.9L304.4,201.9z"/>
        <path d="M352.5,95.2l35.3,0.6l-4.6-35.2L346.9,60L352.5,95.2z"/>
        <path d="M390.2,97.8l6.2,54.7l56.4-1l-8.1-55.2L390.2,97.8z"/>
        <path d="M434.6,62.7l3.8,33.9l34.9-0.6l-5-34.2L434.6,62.7z"/>
        <path d="M397,23.9l3.8,33.9l35-0.6l-5-34.2L397,23.9z"/>
      </g>
    </svg>
  );
};

export default Logo;